// @flow
import { Record, Map, List } from 'immutable';

export const SpaceRecord = Record({
	spaceKey: '',
	name: '',
	watching: null,
});

export const TopicRecord = Record({
	id: 0,
	title: '',
	description: '',
	questionsCount: 0,
	logoUrl: '',
	featured: 0,
	versionNumber: 0,
	confluenceCloud: false,
	watching: null,
});

export const UserRecord = Record({
	accountId: '',
	username: '',
	displayName: '',
	profilePicture: Map({}),
});

export const ExpertRecord = Record({
	accountId: '',
	score: 0,
	answers: 0,
	acceptedAnswers: 0,
	user: new UserRecord(),
});

export const AdminConfigRecord = Record({
	notificationsEnabled: true,
});

export const CommentRecord = Record({
	id: null,
	title: null,
	viewContent: null,
	editorContent: null,
	operations: Map({}),
	history: Map({}),
	version: Map({}),
	author: new UserRecord(),
});

export const AnswerRecord = Record({
	id: null,
	title: null,
	comments: List([]),
	viewContent: null,
	editorContent: null,
	votes: 0,
	operations: Map({}),
	history: Map({}),
	version: Map({}),
	author: new UserRecord(),
	container: null,
	userVote: null, // current user voting details
});

export const QuestionRecord = Record({
	id: null,
	title: null,
	viewContent: null,
	editorContent: null,
	votes: 0,
	answersCount: 0,
	comments: List([]),
	labels: [],
	operations: Map({}),
	history: Map({}),
	version: Map({}),
	author: new UserRecord(),
	space: new SpaceRecord(),
	userVote: null, // current user voting details,
	acceptedAnswer: null,
	watching: null,
	url: null,
	status: '',
});

export const VoteRecord = Record({
	id: null,
	contentId: null,
	accountId: null,
	votedDown: false,
	votedUp: false,
});

export const DeleteConfirmationRecord = Record({
	visible: false,
	id: null,
	parentId: null,
	questionId: null,
	type: null,
});
